<template>
  <div class="content-wrapper">
    <div class="line1">
      <div
        class="advice-wrapper"
        v-for="(item, index) in homeIntroductions"
        :key="index"
        @click="handleClickOpenDialog(item)"
      >
        <img :src="item.bgImage" :alt="item.title" />
      </div>
    </div>

    <el-dialog
      class="intro-dialog"
      :title="introForm.title"
      :visible.sync="introDialog"
      v-if="introDialog"
      center
      width="40%"
    >
      <div v-if="introForm.content" class="center">
        <p v-for="(item, index) in introForm.content" :key="index">
          {{ item }}
        </p>
      </div>
      <div v-else class="padding40">
        <div
          v-for="(item, index) in introForm.typeList"
          :key="index"
          class="type-item"
        >
          <h4 class="typeTitle">{{ item.typeName }}</h4>
          <div>
            <p
              class="textIdent"
              v-for="(content, index) in item.contents"
              :key="index"
            >
              {{ content }}
            </p>
          </div>
          <div class="typeImg-wrapper">
            <img
              class="typeImg"
              v-for="(src, index) in item.imgList"
              :key="index"
              :src="src"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="handleClickClose">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { homeIntroductions } from '@src/constant/home'
@Component()
// 注意修改class名
export default class TrainerGuide extends Vue {
  @Prop(Object)
  data

  @Emit('dialog-show')
  postDialog() {}

  homeIntroductions = homeIntroductions
  introForm = {}
  introDialog = false

  handleClickOpenDialog(item) {
    this.postDialog(item)
    console.log(this.item, '测试item')
    // this.introDialog = true
    // this.introForm = { ...item }
  }

  // handleClickClose() {
  //   this.introDialog = false
  // }
}
</script>

<style lang="scss" scoped>
.intro-dialog .el-dialog__title {
  color: #3dcc85 !important;
}
.content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  // flex-wrap: wrap;
  .line1 {
    width: 100%;
    margin-top: 150px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding-bottom: 60px;
    .advice-wrapper {
      box-sizing: content-box;
      width: 320px;
      height: 405px;
      padding: 0 0px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
